import { useContext } from 'react';
import { ExposureUpdateJobContext } from '../exposure-update-job/context';

export default function useUpdateExposuresJobContext() {
  return useContext(ExposureUpdateJobContext);
}
